/**
 * Los movimientos del WOD, y las reps que salen de ellos.
 *
 * Esto mismo lo calcula Postgres en `reps_from_progress` (0034), que es
 * la version que manda: es la que ordena la tabla. Aqui se repite porque
 * la tablet del juez trabaja sin red y tiene que poder ensenar el numero
 * en el momento del corte, no cuando vuelva el wifi.
 *
 * Que haya dos implementaciones de la misma cuenta es una deuda asumida,
 * y por eso estas pruebas existen: si divergen, el juez ve un CAP+N y el
 * leaderboard publica otro.
 */
function ordenados(segments) {
    return [...segments].sort((a, b) => a.sort_order - b.sort_order);
}
/** El total del WOD. Es el `rep_target` y ya no se teclea a mano. */
export function totalReps(segments) {
    return segments.reduce((suma, s) => suma + s.reps, 0);
}
/**
 * Reps hechas segun el avance.
 *
 * `segmentsDone` se recorta al numero de movimientos que existen, y
 * `partialReps` a lo que quepa en el movimiento en curso: si el juez
 * marca 12 de un bloque de 9, lo que vio fue el bloque completo.
 */
export function repsFromProgress(segments, progress) {
    const lista = ordenados(segments);
    const hechos = Math.max(0, Math.min(Math.floor(progress.segmentsDone), lista.length));
    const completos = lista.slice(0, hechos).reduce((suma, s) => suma + s.reps, 0);
    // Sin movimiento en curso --termino el WOD-- lo parcial no existe.
    const enCurso = lista[hechos];
    if (!enCurso)
        return completos;
    const parcial = Math.max(0, Math.min(Math.floor(progress.partialReps), enCurso.reps));
    return completos + parcial;
}
/**
 * El movimiento que el atleta tiene delante, si queda alguno.
 *
 * Es donde la tablet abre el contador de reps parciales.
 */
export function currentSegment(segments, segmentsDone) {
    const lista = ordenados(segments);
    const hechos = Math.max(0, Math.min(Math.floor(segmentsDone), lista.length));
    return lista[hechos] ?? null;
}
/**
 * Lo que le faltaba, que es el numero que se publica como CAP+N.
 *
 * Nunca negativo: si alguien apunta mas reps que el total del WOD, lo
 * que se ensena es que no le faltaba nada, no un CAP+-3.
 */
export function capRemaining(segments, reps) {
    return Math.max(0, totalReps(segments) - Math.max(0, reps));
}
/**
 * Si esta lista de movimientos se puede usar.
 *
 * Devuelve null si esta bien. El orden repetido importa: el indice unico
 * de Postgres lo rechazaria, y mejor decirlo antes de guardar.
 */
export function validateSegments(segments) {
    if (segments.length === 0)
        return 'Añade al menos un movimiento.';
    const vistos = new Set();
    for (const s of segments) {
        if (!s.movement.trim())
            return 'Hay un movimiento sin nombre.';
        if (!Number.isInteger(s.reps) || s.reps <= 0) {
            return `"${s.movement.trim()}" necesita un número de reps mayor que cero.`;
        }
        if (vistos.has(s.sort_order))
            return 'Dos movimientos tienen el mismo orden.';
        vistos.add(s.sort_order);
    }
    return null;
}
//# sourceMappingURL=segments.js.map